<template>
    <b-modal v-model="modalAberto" size="xl" @hidden="cancelar" button-size="md" hide-footer
        :title="prefix + title ">
        <b-form-row>
            <b-col cols="4"></b-col>

            <lg-form-date invalidFeedback=" " description="Informe o período da data de entrega"
                v-model="form.dtInicial" label="Data:" cols="2" />

            <lg-form-date invalidFeedback=" " description="Informe o período da data de entrega" v-model="form.dtFinal"
                label="Até:" cols="2" />

        </b-form-row>
        <div class="images-container">
            <img :src="imgPdf" class="img" id="pdfRelatorioDepreciacao" alt="icone pdf" @click="gerarPDF" />
            <b-tooltip target="pdfRelatorioDepreciacao" title="PDF"></b-tooltip>

            <b-button id="cancelarModalDeprecriacao" class=" my-2 ml-2" size="sm" pill variant="danger" @click="cancelar">
                <b-icon icon="x-circle" />
                <b-tooltip target="cancelarModalDeprecriacao" title="Cancelar"></b-tooltip>

            </b-button>

        </div>


    </b-modal>
</template>

<script>
import IBPService from '@/core/api/IBPService';
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import PdfIcon from "@/core/assets/icons/pdf.png";
import { geradorDePdf } from '@/modules/patrimonio/item-bem-permanente/geradordocs/pdfs';

export default {
    name: "ModalHistoricoAlteracaoList",
    components: {
        LgFormDate
    },
    props: {
        id: Number,
        prefix: {
            tipe: String,
            default: "",
        },
        title: {
            tipe: String,
            default: "Relatório de Depreciação",
        },

    },
    data() {
        return {
            modalAberto: true,
            form: {
                dtInicial: '',
                dtFinal: ''
            },
            imgPdf: PdfIcon,

        }
    },
    beforeMount() {
        this.$service = new IBPService();
    },

    methods: {
        cancelar() {
            this.$emit('fecharModal');
        },
        fecharModal() {
            this.$emit('fecharModal');
        },
        gerarPDF() {

            if ((!this.form.dtInicial || this.form.dtInicial == '') || (!this.form.dtFinal || this.form.dtFinal == '')) {
                this.$notify({
                    type: "danger",
                    message: `É necessário digitar as duas datas!`,
                });
                return;
            }
            this.$service.listaDepreciacaoIbpNaturezaDespesa(this.id, this.form.dtInicial, this.form.dtFinal).then(response => {
                geradorDePdf("rDIBP", response.data.itemBemPermanente, "DEPRECIAÇÃO DE BEMPERMANENTE", response.data);

            });
        }


    }
}

</script>